import React, { Component } from 'react';

const isSandals = window._app.brandOptions.isSandals;

class GTMCookie extends Component {
  componentDidMount() {
    this._setGTMCookie();
  }

  _setGTMCookie() {
    const name = 'checkout_version';
    const value = 'old';
    const domain = isSandals ? '.sandals.com' : '.beaches.com';
    const date = new Date();

    date.setMonth(date.getMonth() + 2);
    const expirationDate = date.toUTCString();

    document.cookie = `${name}=${value};expires=${expirationDate};domain=${domain}`;
  }
  render() {
    return(
      <div>{ '' }</div>
    );
  }
}

export default GTMCookie;




// WEBPACK FOOTER //
// ./js/components/global/GTMCookie.js